import React, { useCallback, useState } from 'react';

import api from '../api';
import { useGet, useGetOne, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';
import { ServicePrice } from '../types';

import Context from './context';

type Props = { children: React.ReactNode };

const ServicePricesProvider: React.FC<Props> = ({ children }: Props) => {
    const [data, setData] = useState<Array<ServicePrice>>([]);
    const [selected, setSelected] = useState<ServicePrice | null>(null);
    const [error, setError] = useState({});

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const getOne = useGetOne(api, setSelected, setError);

    const handleSetData = useCallback((item, newData) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const handleDeleteCallback = useCallback((id, newData) => {
        setData(newData);
        setSelected(null);
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    const getIsExistInMoreThenOneSameService = useCallback((id, serviceModelType) => {
        return api
            .getIsExistInMoreThenOneSameService(id, serviceModelType)
            .then((isExistInMoreThenOneTour: boolean) => {
                return isExistInMoreThenOneTour;
            })
            .catch((err: any) => {
                setError(err);
                throw err;
            });
    }, []);

    return (
        <Context.Provider
            value={{
                get,
                getOne,
                post,
                put,
                remove,
                softDelete,
                data,
                setData,
                selected,
                setSelected,
                error,
                getIsExistInMoreThenOneSameService
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default ServicePricesProvider;
